import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import memoize from 'lodash/memoize';
import React, { type ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { AriaRoles } from '../../../../../constants/AccessibilityConstants';
import { fullSearch, resetResults } from '../../../actions';
import { messages as m, SearchKeys } from '../../../constants';
import * as D from '../../../deps';
import SearchListItem from '../../SearchListItem';
import EmptySearch from '../EmptySearch';

import './SearchResultsList.scss';

interface ISearchResultsListsProps {
  activeUrl: string;
  closeSearch: $TSFixMeFunction;
  ctaButton?: ReactNode;
  hasFetchedData?: boolean;
  hasResults: boolean;
  infiniteList: ReactNode;
  isOnboardingPage: boolean;
  isRightRailActive: boolean;
  navTheme: string;
  receivedResultsInLastRequest?: boolean;
  reFetchData: $TSFixMeFunction;
  searchResultsRendered: $TSFixMeFunction;
  searchTerm: string;
  searchType: string;
  shouldDropSearchToNextLine: boolean;
  showColdStart: boolean;
}

export class SearchResultsList extends React.Component<ISearchResultsListsProps> {
  // @ts-expect-error TS(7006) FIXME: Parameter 'nextProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentWillUpdate(nextProps): $TSFixMeFunction {
    if (
      nextProps.searchTerm !== this.props.searchTerm ||
      nextProps.activeUrl !== this.props.activeUrl
    ) {
      this.props.reFetchData(resetResults);
    }
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'prevProps' implicitly has an 'any' type... Remove this comment to see the full error message
  componentDidUpdate(prevProps): $TSFixMeFunction {
    if (!prevProps.hasFetchedData && this.props.hasFetchedData) {
      D.Utils.Time.markTimeAtMomentForQuery(
        D.Constants.App.SearchCheckpointMarks.SEARCH_STATS_RESULTS_RENDER,
        this.props.searchTerm,
      );
      this.props.searchResultsRendered({
        searchTerm: this.props.searchTerm,
        searchFilter: this.props.activeUrl.substring(1),
      });
    }
  }

  maybeCloseSearch: $TSFixMeFunction = event => {
    const targetClassName = get(event, ['target', 'className'], false);
    const targetParentClassName = get(event, ['target', 'parentNode', 'className'], false);
    const className = targetClassName || targetParentClassName;
    if (className && !className.includes('SearchResultsList__list')) {
      return;
    }
    this.props.closeSearch(event);
  };

  render(): $TSFixMe {
    const searchContentClasses = D.Utils.Css.createBEM('SearchResultsList__content', {
      isColdStartWelcome: this.props.showColdStart,
    });

    let searchContent = (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div role={AriaRoles.SEARCH} className={searchContentClasses} onClick={this.maybeCloseSearch}>
        {/* @ts-expect-error TS(2322) FIXME: Type 'string' is not assignable to type 'number'. */}
        <p id='searchKeyboardControls' tabIndex='-1' aria-live='polite' className='visuallyHidden'>
          <FormattedMessage {...m.searchKeyboardControls} />
        </p>
        {this.props.infiniteList}
      </div>
    );

    if (!this.props.hasResults && this.props.hasFetchedData) {
      searchContent = (
        <EmptySearch
          closeSearch={this.props.closeSearch}
          term={this.props.searchTerm}
          hasResults={this.props.hasResults}
          filter={this.props.activeUrl.substring(1)}
          isColdStartWelcome={this.props.showColdStart}
          ctaButton={this.props.ctaButton}
        />
      );
    }
    const resultsListClasses = D.Utils.Css.createBEM('SearchResultsList', {
      [this.props.navTheme]: !isEmpty(this.props.navTheme),
      coldStartWelcome: this.props.showColdStart && !this.props.isOnboardingPage,
      nav: !this.props.isOnboardingPage,
      onboardingStyle: this.props.isOnboardingPage,
      rightRail: this.props.isRightRailActive,
      shouldDropSearchToNextLine: this.props.shouldDropSearchToNextLine,
    });

    return <div className={resultsListClasses}>{searchContent}</div>;
  }
}

function getApiCall(
  searchTerm: $TSFixMe,
  searchFilter: $TSFixMe,
  searchTime: $TSFixMe,
  searchType: $TSFixMe,
  infiniteListArgs: $TSFixMe,
): $TSFixMe {
  if (infiniteListArgs.startIndex !== 0) {
    D.Utils.Time.markTimeAtMomentForQuery(
      D.Constants.App.SearchTriggerMarks.SEARCH_STATS_SCROLL_QUERY,
      searchTerm,
    );
  }
  const props = { searchFilter, searchTerm, searchTime, searchType };
  return fullSearch(Object.assign({}, infiniteListArgs, props));
}

// @ts-expect-error TS(7006) FIXME: Parameter 'query' implicitly has an 'any' type.
const dataFetcherMemoFunc = (query, type, searchTime): $TSFixMeFunction =>
  query + type + searchTime;

const _listItemProps = memoize((searchResult, activeUrl, closeSearch, onItemSelect) => {
  const results = searchResult.toJS();

  // @ts-expect-error TS(7006) FIXME: Parameter 'result' implicitly has an 'any' type.
  results.forEach((result, index) => {
    result.activeUrl = activeUrl;
    result.closeSearch = closeSearch;
    result.onItemSelect = onItemSelect;
    result.index = index;
  });
  return results;
});

// @ts-expect-error TS(7006) FIXME: Parameter 'state' implicitly has an 'any' type.
export const mapStateToProps = (state, ownProps): $TSFixMe => {
  const props: $TSFixMe = {};
  const searchTerm = state.searchT3.getIn(['mainSearch', SearchKeys.SEARCH_TERM]);
  const receivedResultsInLastRequest = state.searchT3.get(
    SearchKeys.RECEIVED_RESULTS_IN_LAST_REQUEST,
  );
  props.hasFetchedData = state.searchT3.get(SearchKeys.FETCHED_SEARCH_RESULTS);
  props.isRightRailActive = D.getInDomain('ads.utils.getIsRightRailActive', false)(state);
  // We use searchTime to determine if the results received match the query entered.
  // If both time stamps match, we render the results.
  const searchTime = state.searchT3.getIn([SearchKeys.SEARCH_TIMES, 0]);
  if (ownProps.activeUrl) {
    const apiCall = D.getDataFetcher(
      dataFetcherMemoFunc,
      getApiCall,
      searchTerm,
      ownProps.activeUrl.slice(1),
      searchTime,
      ownProps.searchType,
    );
    const searchResults = state.searchT3.get(SearchKeys.SEARCH_RESULTS);
    props.listItemProps = _listItemProps(
      searchResults,
      ownProps.activeUrl.slice(1),
      ownProps.closeSearch,
      ownProps.onItemSelect,
      // @ts-expect-error TS(2554) FIXME: Expected 4 arguments, but got 5.
      receivedResultsInLastRequest,
    );
    // This exists because the api doesn't ever give us a total
    // but we have to let the infinite list know that we've received
    // all we're going to receive which we determine as when we have results
    // and the last request was empty
    if (searchResults.size && !receivedResultsInLastRequest) {
      props.listItemTotal = searchResults.size;
    }
    props.onInfiniteScroll = D.getOnInfiniteScroll(
      `${ownProps.searchTerm}:${ownProps.activeUrl.slice(1)}:${searchTime}`,
      props.listItemProps,
      apiCall,
      props.hasFetchedData,
      props.listItemTotal,
      20,
    );
    props.receivedResultsInLastRequest = receivedResultsInLastRequest;
  }
  return props;
};

// The || is just for tests, since we don't import css to unit tests
export const LIST_ITEM_HEIGHT = D.RowItemHeights.DEFAULT || 0;

const accessibleAttributes = {
  'aria-selected': false,
  role: AriaRoles.OPTION,
  tabIndex: -1,
};

const listProperties = {
  accessibleAttributes,
  className: 'SearchResultsList',
  listItemComponent: SearchListItem,
  listItemHeight: LIST_ITEM_HEIGHT,
  pageSize: 20,
  specialLastRow: (ctaButton: $TSFixMe): $TSFixMe => (
    <div className='SearchResultsList__buttonWrapper'>
      <h4 className='SearchResultsList__buttonWrapper__title'>
        <FormattedMessage {...m.wantHelp} />
      </h4>
      {ctaButton}
    </div>
  ),
};

export default connect(mapStateToProps)(D.InfiniteScrolledList(SearchResultsList, listProperties));
